import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import {MenuItem, LazyLoadEvent,} from 'primeng/api';
import {DocumentTemplateService} from '../../../services/document-template.service';
import { IGlobalSearchParam, ISearchGlobalFilter } from '../../../../shared/models/Global-Search.model';
import {DialogService} from 'primeng/dynamicdialog';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import { Message } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { SharedService } from '../../../../shared/services/shared.service';
import { SelectItem, FilterService, FilterMatchMode } from "primeng/api";
import { Table } from 'primeng/table';
import { DocumentTemplate } from 'src/app/admin/models/document-template.model';
import { ExcelService } from 'src/app/shared/services/excel.service';
;
import { DocumentTemplateViewModalComponent } from '../../document-template/document-template-view-modal/document-template-view-modal.component';
import { Router, ActivatedRoute } from '@angular/router';
import * as fs from 'file-saver';
import { User } from '../../../../../../src/app/auth/models';


@Component({
  selector: 'app-document-template-search',
  templateUrl: './document-template-search.component.html',
  styleUrls: ['./document-template-search.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})
export class DocumentTemplateSearchComponent implements OnInit {

  showTopFilters: boolean;
   showFilters:boolean;
   showSorting:boolean;
   matchModeOptions: SelectItem[];
   matchModeOptionsForDate: SelectItem[];
   matchModeOptionsForNumeric: SelectItem[];
   showAddRuleButton:boolean = false;
   oldSortField:string = 'createdOn';
   oldSortOrder:string = 'desc';
   sortField:string = 'createdOn';
   sortOrder:string = 'desc';
   appliedFilters:{field:string,matchMode:string,value:string}[]=[];
   pageNo: number =1;
   pageSize: number =10;
   oldPageNo: number =1;
   oldPageSize: number =10;
   totalRecords: number;
   loadEvent: LazyLoadEvent;
   filters;
   filterCondition: { fieldName: string; type: string; }[] =[];
   startSearch: boolean = false;
   documentTemplateList;
   gridSpinner = 'gridSpinner1';
   isSearchLoading: boolean = false;
   loading: boolean = false;
   documentTemplateSearchParam:IGlobalSearchParam;
   items: MenuItem[];
   documentTemplateSearchSpinner = 'documentTemplateSearchSpinner';
   ref: DynamicDialogRef;
   msgs: Message[] = [];
   dialogPosition = 'topright';
   isDocumentTemplateAdd : boolean = false;
   isDocumentTemplateEdit : boolean = false;
   buttonLabel: string = "";
   title: string = "";
   documentTemplateForm:FormGroup;
   selectedGridMenuItem:any = null;
   showToggle:boolean;
   isshowpaginator:boolean=true;
   statusValues:any;
   selectedStatusId:any="All";
   selectedStatus:any;
   loggedInUserProfile: User;
   allColumns = [
    { value: 'action', header: 'Action' },
    { value: 'templateName', header: 'Template Name' },
    { value: 'screenName', header: 'Screen Name' },
    { value: 'isActive', header: 'Is Active' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' }
  ]

  selectedColumns = [
    { value: 'action', header: 'Action' },
    { value: 'templateName', header: 'Template Name' },
    { value: 'screenName', header: 'Screen Name' },
    { value: 'isActive', header: 'Is Active' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' }
  ]
  @ViewChild('dt2', { static: true }) table: any;


  constructor(
    public datepipe: DatePipe,
    // private storage: LocalStorageService,
     private spinner: NgxSpinnerService,
     private documentTemplateService:DocumentTemplateService,
     private dialogService: DialogService,
     private confirmationService: ConfirmationService,
     private messageService: MessageService,
     private primengConfig: PrimeNGConfig,
     private _fb: FormBuilder,
     private excelService:ExcelService,
     private _router: Router,
     public sharedService: SharedService
  ) { 
    this.showFilters = false;
    this.showSorting = false;
    this.spinner.show();
    setTimeout(() => {
        this.spinner.hide();
    }, 1000);
  }

  ngOnInit(): void {
    this.checkViewPermission();
    this.items = [];
    this.checkEditDeletePermission();
     const customFilterName = "custom-equals";
     const notEquals = "not-equals";
     const dateAfter = "date-after";
     const dateBefore = "date-before";
     
     this.matchModeOptions = [
       { label: "Custom Equals", value: customFilterName },
       { label: "Starts With", value: FilterMatchMode.STARTS_WITH },
       { label: "Contains", value: FilterMatchMode.CONTAINS }
     ];
 
     this.matchModeOptionsForDate = [
      { label: "Equals", value: customFilterName },
      { label: "Not Equals", value: notEquals },
      { label: "Greater Than", value: dateAfter },
      { label: "Less Than", value: dateBefore },
     ];
 
     this.matchModeOptionsForNumeric = [
       { label: "Custom Equals", value: customFilterName },
       { label: "Greater than or equal to", value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
       { label: "Less than or equal to", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
     ];
 
     this.filterCondition=[
       {fieldName:"templateName",type:"basic"},
       {fieldName:"screenName",type:"basic"},
       {fieldName:"isActive",type:"basic"},
       {fieldName:"createdBy",type:"basic"},
       {fieldName:"createdOn",type:"date"},
     ];
     this.appliedFilters.push({ field:"globalfilter", matchMode:"equals", value:"0" }) 
     this.getAllDocumentTemplateList();
     this.statusValues=['All','Active',"Inactive"];
     this.InitialSetup();
  }
  checkViewPermission()
   {
     var result = this.sharedService.checkPermission("Admin_View");
     if(!result)
     this._router.navigateByUrl('/login');
   }
   InitialSetup(){
    this.documentTemplateForm = this._fb.group({
      docTemplateId: new FormControl(0,[Validators.required]),
      templateName: new FormControl("",[Validators.required]),
      screenName: new FormControl("",[Validators.required]),
      description: new FormControl("",[Validators.required]),
      isActive: new FormControl(false,[Validators.required]),
      createdBy: new FormControl(""),
      createdOn: new FormControl(""),
      modifiedBy: new FormControl(""),
      modifiedOn: new FormControl("")
    })
  }
  getAllDocumentTemplateList()
   {
     this.documentTemplateSearchParam = 
        {
          pageNo:this.pageNo,
          pageSize:this.pageSize,
          sortField:this.sortField,
          appliedFilters:this.appliedFilters,
          sortOrder:this.sortOrder
        };
        this.spinner.show(this.documentTemplateSearchSpinner);
     this.documentTemplateService.getAllDocumentTemplates(this.documentTemplateSearchParam).subscribe((data: any) => {
       this.appliedFilters = [];
       this.documentTemplateList =data;
       this.isshowpaginator=this.documentTemplateList.length>0?true:false;
       console.log(this.documentTemplateList);
       this.totalRecords = data[0].totalCount;
       this.spinner.hide(this.documentTemplateSearchSpinner);
      });
   }
   loadDocumentTemplateList(event:LazyLoadEvent)
   { 
     this.loadEvent=event;
     if(event.first==0)
     {
       this.pageNo = 1;
     }
     else {
       this.pageNo=(event.first/event.rows)+1;
     }
     this.pageSize=event.rows;
     
     this.pageSize=event.rows;
     
     if((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize))
     {
      this.applyFilter();
      this.getAllDocumentTemplateList();
     }
     this.oldPageNo = this.pageNo;
     this.oldPageSize = this.pageSize;
     this.filters=event.filters;
     if(this.filters["createdOn"]!= undefined)
     {
     if(this.filters["createdOn"][0].matchMode == "date-after")
     {
        this.showAddRuleButton = true;
     }
     else{
       this.showAddRuleButton = false;
     }
    }
     this.sortField=event.sortField;
     if(event.sortField === undefined || event.sortField === null)
     {
       this.sortField='createdOn';
     }
     if(event.sortOrder === 1)
     {
     this.sortOrder='desc';
     }
     if(event.sortOrder === -1)
     {
     this.sortOrder='asc';
     }
     if(this.oldSortField !==  this.sortField ||  this.oldSortOrder !== this.sortOrder)
     {
       this.applyFilter();
       this.getAllDocumentTemplateList()
     }
     this.oldSortField = this.sortField;
     this.oldSortOrder = this.sortOrder;
   }

   search()
   {
     console.log(this.filterCondition.length);
     for(let i=0;i<this.filterCondition.length;i++)
     {
       if(this.filterCondition[i].type == "checkbox")
       {
         if(this.filters[this.filterCondition[i].fieldName].value == true)
         {
           this.appliedFilters.push({field:this.filterCondition[i].fieldName,matchMode:this.filters[this.filterCondition[i].fieldName].matchMode ,value:"true"}) 
         }
         else if (this.filters[this.filterCondition[i].fieldName].value == false){
           this.appliedFilters.push({field:this.filterCondition[i].fieldName,matchMode:this.filters[this.filterCondition[i].fieldName].matchMode ,value:"false"}) 
         }
       }
       else {
         this.appliedFilters.push({field:this.filterCondition[i].fieldName,matchMode:this.filters[this.filterCondition[i].fieldName].matchMode ,value:this.filters[this.filterCondition[i].fieldName].value}) 
       }
       if(i==this.filterCondition.length-1 )
       {
         this.startSearch = true; 
       } 
     }
     if(this.startSearch == true)
     {
       this.documentTemplateSearchParam = 
        {
          pageNo:this.pageNo,
          pageSize:this.pageSize,
          sortField:this.sortField,
          appliedFilters:this.appliedFilters,
          sortOrder:this.sortOrder
        };
        this.spinner.show(this.documentTemplateSearchSpinner);
       this.documentTemplateService.getAllDocumentTemplates(this.documentTemplateSearchParam).subscribe((data: any) => {
         this.appliedFilters = [];
         this.documentTemplateList =data;
         console.log(this.documentTemplateList);
         this.totalRecords = data[0].totalCount;
         this.spinner.hide(this.documentTemplateSearchSpinner);
        });
     }
   }

   showDocumentTemplateDetails(paramId: number)
   {
    this._router.navigate(['/document-template-view'], { queryParams: { id: paramId } });
   }

   deleteConfirm(paramId:number) {
    this.dialogPosition = 'topright';
    console.log('deleteConfirm');
    this.confirmationService.confirm({
      message: 'Do you want to delete this document template?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        console.log("hi");
        this.documentTemplateService.deleteDocumentTemplate(paramId).subscribe((data: any) => {
          this.getAllDocumentTemplateList();
          this.messageService.add({severity:'info', summary:'Confirmed', detail:'You have deleted the record'});
         });
      },
      reject: (type) => {
        switch(type) {
            case ConfirmEventType.REJECT:
                this.messageService.add({severity:'error', summary:'Rejected', detail:'You have rejected'});
            break;
            case ConfirmEventType.CANCEL:
                this.messageService.add({severity:'warn', summary:'Cancelled', detail:'You have cancelled'});
            break;
        }
      },
      key: "positionDialog"
    });
  }

   addDocumentTemplateDetails(){
    
    this._router.navigate(['/document-template-add']);
    
  }

  editDocumentTemplateDetails(paramId: number)
   { 
     
     this._router.navigate(['/document-template-add'], { queryParams: { id: paramId } });
   }

   cancel(){
    this.isDocumentTemplateAdd = false;
    this.isDocumentTemplateEdit = false;
  }

  save({value}: {value: DocumentTemplate}){
    console.log(value);
    if(value.docTemplateId == 0){
      //value.createdBy = 1;
      this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
      value.createdBy = Number (this.loggedInUserProfile.uid);
      value.createdOn = new Date();
      this.documentTemplateService.postDocumentTemplate(value).subscribe(data => {
        this.getAllDocumentTemplateList();
        this.isDocumentTemplateAdd = false;
      }, error => {
        console.log(error)
      })
    }
    else{
      this.documentTemplateService.updateDocumentTemplate(value.docTemplateId, value).subscribe(data => {
        this.getAllDocumentTemplateList();
        this.isDocumentTemplateEdit = false;
      }, error => {
        console.log(error);
      })
    }
  }
  clearFilter(table: Table) {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
       this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
    table.clear();
    this.selectedStatus="";
    this.selectedStatusId=undefined;
    this.appliedFilters = [];
   //  this.applyFilter();
   this.getAllDocumentTemplateList();
  }

  bindShowFilter() {
    this.showFilters = (this.showFilters ? false : true)
  }

  bindShowSorting() {
    this.showSorting = (this.showSorting ? false : true)
  }

  bindShowTopFilter() {
    this.showTopFilters = (this.showTopFilters ? false : true)
  }

  applyFilterNew(table: Table){
    this.filters=table.filters;
    this.applyFilter();
  }

  applyFilter()
   {
     console.log(this.filterCondition.length);
     console.log(this.filterCondition);
     console.log(this.filters);
     if (Object.keys(this.filters).length > 1) {
       this.appliedFilters = [];
       for (let i = 0; i < this.filterCondition.length; i++) {
         if (this.filterCondition[i].type == "checkbox") {
           if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
             if (this.filters[this.filterCondition[i].fieldName][0].value == true) {
               this.appliedFilters.push({
                 field: this.filterCondition[i].fieldName,
                 matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                 value: "true"
               })
             }
             else if (this.filters[this.filterCondition[i].fieldName][0].value == false) {
               this.appliedFilters.push({
                 field: this.filterCondition[i].fieldName,
                 matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                 value: "false"
               })
             }
           }
         }
         else if (this.filterCondition[i].type == "basic") {
           console.log("filter type is basic");
           if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
             if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
               console.log("filter field name is "+[this.filterCondition[i].fieldName][0]);
               this.appliedFilters.push({
                 field: this.filterCondition[i].fieldName,
                 matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                 value: this.filters[this.filterCondition[i].fieldName][0].value
               })
             }
           }
         }
         else if (this.filterCondition[i].type == "date") {
           if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
             for (let j = 0; j <= this.filters[this.filterCondition[i].fieldName].length - 1; j++) {
               if (this.filters[this.filterCondition[i].fieldName][j].value !== null)
                 this.appliedFilters.push({
                   field: this.filterCondition[i].fieldName,
                   matchMode: this.filters[this.filterCondition[i].fieldName][j].matchMode,
                  //  value: this.filters[this.filterCondition[i].fieldName][j].value
                  value: this.datepipe.transform(this.filters[this.filterCondition[i].fieldName][j].value,"MM-dd-yyyy")
                 })
             }
           }
         }
         else if (this.filterCondition[i].type == "numeric") {
           if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
             if (this.filters[this.filterCondition[i].fieldName][0].value !== null)
               this.appliedFilters.push({
                 field: this.filterCondition[i].fieldName,
                 matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                 value: this.filters[this.filterCondition[i].fieldName][0].value
               })
           }
         }
     }
     }
 
     if(this.startSearch == true || this.startSearch == false)
     {
       this.documentTemplateSearchParam = 
        {
          pageNo:this.pageNo,
          pageSize:this.pageSize,
          sortField:this.sortField,
          appliedFilters:this.appliedFilters,
          //searchGlobalFilter: this.searchGlobalFilter,
          sortOrder:this.sortOrder
        };
       this.spinner.show(this.documentTemplateSearchSpinner);
       this.documentTemplateService.getAllDocumentTemplates(this.documentTemplateSearchParam).subscribe((data: any) => {
       this.documentTemplateList =data;
       this.isshowpaginator=this.documentTemplateList.length>0?true:false;
       console.log(this.documentTemplateList);
       this.totalRecords = data[0].totalCount;
       this.spinner.hide(this.documentTemplateSearchSpinner);
       });
     }
   }

   bindShowToggle() {
    this.showToggle = (this.showToggle ? false : true)
  }

  showAndHideColumn(event){
    this.selectedColumns = event.value;
  }

  isShowColumns(columnName){
    var tempColumn = this.selectedColumns.filter(col => col.value == columnName);
    if(tempColumn.length == 1){
      //console.log("length is "+tempColumn.length);
      return true;
    }
    return false;
  }

  checkEditDeletePermission() {
    var isAdminAdd = this.sharedService.checkPermission("Admin_Add");
    var isAdminDelete = this.sharedService.checkPermission("Admin_Delete");
    if (isAdminAdd) {
      var editItem = {
        label:'Edit',
        icon:'pi pi-fw pi-pencil',
        command: e => this.editDocumentTemplateDetails(this.selectedGridMenuItem.docTemplateId)
      }
      this.items.push(editItem)
    }
    if(isAdminDelete){
      var deleteItem =  {
        label:'Delete',
       icon:'pi pi-fw pi-trash',
       command: e => this.deleteConfirm(this.selectedGridMenuItem.docTemplateId)
       }
       this.items.push(deleteItem);
    }
  }

  getStatusOnChange(event)
 {
  this.selectedStatusId = event.value;
  this.selectedStatus=event.value;
 }

 clearStatus()
 {
  this.selectedStatus ="";
  this.selectedStatusId = undefined;
 }

}
